import { useSubscriptionStore } from '@repo/subscription/client';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import { useUserStore } from '../userStore';

import { paymentStoreStateCreator } from './state';

export type { Services } from './types';
export * from './selector';

export const usePaymentStore = create(
  subscribeWithSelector(paymentStoreStateCreator)
);

useUserStore.subscribe(
  (state) => (state.user || null)?.id,
  () => {
    usePaymentStore.getState().actions.reset();
  }
);

useSubscriptionStore.subscribe(
  (state) => state.stripeAccountCountry,
  (stripeAccountCountry) => {
    if (stripeAccountCountry) {
      usePaymentStore
        .getState()
        .actions.setStripeAccountCountry(stripeAccountCountry);
    }
  }
);
